import { render, staticRenderFns } from "./IndirectServerSidePaginatedTable.vue?vue&type=template&id=3f0ea732&"
import script from "./IndirectServerSidePaginatedTable.vue?vue&type=script&lang=js&"
export * from "./IndirectServerSidePaginatedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports